import axios from "axios";
import * as CORPORATE_ROUTES from "../Router/corporate_routes";

const getAnonymousCompanyFromAgency = async (agency, token) => {
  try {
    const response = await axios.get(
      `${
        window.API
      }${CORPORATE_ROUTES.API.COMPANY.ANONYMOUS_FROM_AGENCY.replace(
        ":agencyId",
        agency
      )}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return { result: response.data };
  } catch (error) {
    return { error };
  }
};

export { getAnonymousCompanyFromAgency };
